export const PinBar = ({ light, m }) => (
  <div className={`desk-pin ${light.color}`} data-testid="desk-pin">
    <span className="flex items-center gap-2 font-extrabold tracking-wider" data-testid="desk-pin-light">
      <i className="desk-pin-dot" />{light.color}
    </span>
    <span className="desk-mono" data-testid="desk-pin-price">
      {m.price ? `$${m.price.toFixed(2)}` : "—"}
      {m.change_pct != null && <span className={`ml-2 ${m.change_pct >= 0 ? "desk-up" : "desk-down"}`}>{m.change_pct >= 0 ? "+" : ""}{m.change_pct}%</span>}
    </span>
  </div>
);
